require('./spritzungDialog');
require('./spritzungUtils');
const $ = require('jquery');

/**
 * spritzung_sortWithParameter
 * @param sort
 * @param recordID
 * @param hasOpenSections
 * @param isAbgegeben
 */
window.spritzung_sortWithParameter = function(sort, recordID, hasOpenSections, isAbgegeben) {
  const checked = $('div[data-section-uid]').has('input:checked').map(function() {
    return parseInt($(this).data('section-uid'));
  }).get();

  const activeButtons = $('.active-buttons');
  if (activeButtons.length > 0) {
    activeButtons.removeClass('active');

    const firstLevelButton = $('#show-first-level');
    if (sort === 'betrieb') {
      firstLevelButton.text(LANG_STRINGS.anlagen);
    } else if (sort === 'sorte' || sort === 'pflanzjahr') {
      firstLevelButton.text(LANG_STRINGS.betriebe);
    }
  }

  const ListAufzeichnungFlaechenSpritzung = new AjaxItem('aufzeichnungFlaechenSpritzung', {}, {}, 'aufzeichnungen');
  ListAufzeichnungFlaechenSpritzung.poster({
    checked: checked,
    sortby: sort,
    recordID: recordID,
    hasOpenSections: hasOpenSections,
    isAbgegeben: isAbgegeben,
  });
};

/**
 * spritzung_showHideLockedDataset
 * @param currentElement
 * @param recordID
 * @param hasOpenSections
 * @param isAbgegeben
 */
window.spritzung_showHideLockedDataset = function(currentElement, recordID, hasOpenSections, isAbgegeben) {
  const checked = $('div[data-section-uid]').has('input:checked').map(function() {
    return parseInt($(this).data('section-uid'));
  }).get();

  const ListAufzeichnungFlaechenSpritzung = new AjaxItem('aufzeichnungFlaechenSpritzung', {}, {}, 'aufzeichnungen');
  ListAufzeichnungFlaechenSpritzung.poster({
    checked: checked,
    recordID: recordID,
    hasOpenSections: hasOpenSections,
    isAbgegeben: isAbgegeben,
    showHideLockedDataset: 1,
  });

  if ($(currentElement).find('span').hasClass('show-txt-0')) {
    $(currentElement).find('span').html(LANG_STRINGS.gesperrteAbschnitteAusblenden);
    $(currentElement).find('span').removeClass('show-txt-0').addClass('show-txt-1');
  } else {
    $(currentElement).find('span').html(LANG_STRINGS.gesperrteAbschnitteEinblenden);
    $(currentElement).find('span').removeClass('show-txt-1').addClass('show-txt-0');
  }
};

/**
 * spritzung_buildAbschnittData
 * @returns {*|jQuery}
 */
/*
window.spritzung_buildAbschnittData = function(getCurrentWasseraufwand = false) {
  let dataSectionID = $('[data-section-uid]');
  dataSectionID.hasNot('input:checked').map(function() {
    spritzung_resetAbschnittData($(this));
  });

  const tableMittel = $('#table-mittel');
  const tableMittelChildren = tableMittel.children(':not(.row-table__head)');
  const wasseraufwandEdit = $('#wasseraufwand-edit');
  const wasseraufwandHaIntern = $('#wasseraufwandHa-intern');

  const abschnitte = {};
  let sumFlaeche = 0;
  let maxWasseraufwand = 0;
  let minWasseraufwand = 0;
  dataSectionID.has('input:checked').map(function() {
    const abschnittBruehe = roundBruehe(Number($(this).find('input.abschnitt-bruehmenge-intern').val()), PSM_BRUEHE_GESAMT_BRUEHE_ABSCHNITT_AUFRUNDEN);
    const abschnittFlaeche = Number($(this).find('input[name="flaeche"]').val());

    // Wasseraufwand überschreiben
    if ($(this).find('input[name="wasseraufwand"]').val() === '' || getCurrentWasseraufwand === true) {
      if (getCurrentWasseraufwand === false && wasseraufwandHaIntern.val() !== '0') {
        $(this).find('input[name="wasseraufwand"]').val(wasseraufwandEdit.val());
      } else {
        const currentWasseraufwand = $(this).find('input[name="wasseraufwand"]').data('current');
        $(this).find('input[name="wasseraufwand"]').val(currentWasseraufwand);
      }
    }

    const abschnittWasseraufwand = Number($(this).find('input[name="wasseraufwand"]').val());
    const abschnittID = Number($(this).attr('data-section-uid'));
    const kultur = Number($(this).attr('data-kultur'));
    const sorte = Number($(this).attr('data-sorte'));
    const richtlinien = $(this).attr('data-quality-ids');

    if (abschnittWasseraufwand > maxWasseraufwand) {
      maxWasseraufwand = abschnittWasseraufwand;
    }
    if (minWasseraufwand === 0) {
      minWasseraufwand = abschnittWasseraufwand;
    } else if (abschnittWasseraufwand < minWasseraufwand) {
      minWasseraufwand = abschnittWasseraufwand;
    }
    let mittelAbschnitt = {};
    let allMittelAbschnittID = [];
    if (tableMittelChildren.length > 0) {
      tableMittelChildren.each(function() {
        if ($(this).data('teilspritzung') == 0) {
          const mittelKey = $(this).data('psm-key') + '-' + $(this).data('psm-id');
          const dosisProHl = Number($(this).find('.list-dosisProHl').val());

          const mittelmengeAbschnittNeu = roundMittelmenge(abschnittBruehe * dosisProHl);
          const mittelmengeProHaNeu = roundMittelmengeProHa(mittelmengeAbschnittNeu / abschnittFlaeche * 10000);

          mittelAbschnitt[mittelKey] = {
            id: mittelKey,
            name: $(this).find('.list-mittelName').val(),
            dataKey: $(this).data('psm-key'),
            psmID: $(this).data('psm-id'),
            dosisProHl: dosisProHl,
            mittelmenge: mittelmengeAbschnittNeu,
            mittelmengeProHa: mittelmengeProHaNeu,
            sectionID: abschnittID,
          };
          allMittelAbschnittID.push(mittelKey);
        }
      });
    }

    abschnitte[abschnittID] = {
      id: abschnittID,
      flaeche: abschnittFlaeche,
      wasseraufwand: abschnittWasseraufwand,
      kultur: kultur,
      sorte: sorte,
      richtlinien: richtlinien,
      bruehe: abschnittBruehe,
      mittel: mittelAbschnitt,
      alleMittelId: allMittelAbschnittID,
    };

    sumFlaeche += Number($(this).find('input[name="flaeche"]').val());
  });
  let hintMessage = '';
  if (minWasseraufwand !== maxWasseraufwand) {
    hintMessage = numberFormat(minWasseraufwand, DECIMAL_PLACES_WASSERAUFWAND, ',') + ' - ' + numberFormat(maxWasseraufwand, DECIMAL_PLACES_WASSERAUFWAND, ',') + ' hl/ha';
  }

  wasseraufwandEdit.parent().next('.hint-message').find('.input-help-message').html(hintMessage);

  // Abschnitt-IDs
  let alleAbschnitteID = [];
  $.each(abschnitte, function(k, v) {
    alleAbschnitteID.push(v.id);
  });

  // Summe
  let sumMittel = {};
  let allMittelID = [];
  if (tableMittelChildren.length > 0) {
    tableMittelChildren.each(function() {

      if ($(this).data('teilspritzung') == 0) {
        const mittelKey = $(this).data('psm-key') + '-' + $(this).data('psm-id');

        sumMittel[mittelKey] = {
          id: mittelKey,
          name: $(this).find('.list-mittelName').val(),
          psmID: $(this).data('psm-id'),
          dataKey: $(this).data('psm-key'),
          dosisProHl: Number($(this).find('.list-dosisProHl').val()),
          mittelmenge: 0.0,
          mittelmengeProHa: 0,
        };

        allMittelID.push(mittelKey);
      }
    });
  }

  // Wasseraufwand berechnet überschreiben
  if (getCurrentWasseraufwand === true) {
    wasseraufwandEdit.val(wasseraufwandEdit.data('current')).parent().next('.hint-message').removeClass('display-none');
    wasseraufwandHaIntern.val('0');
  }

  const summe = {
    flaeche: sumFlaeche,
    bruehe: roundBruehe(Number($('#bruehe-einfach-intern').val())),
    mittel: sumMittel,
    alleMittelId: allMittelID,
  };
  const summeNeu = spritzung_recalculateSumme(summe, alleAbschnitteID, abschnitte, true);
  return {
    abschnitte: abschnitte,
    alleAbschnitteId: alleAbschnitteID,
    summe: summeNeu,
    getCurrentWasseraufwand: getCurrentWasseraufwand,
  };
};*/
/**
 * spritzung_buildAbschnittData
 * @returns {*|jQuery}
 */
window.spritzung_buildAbschnittData = function(getCurrentWasseraufwand = false, isTeilspritzung = false) {
  let sectionIdentifier = 'data-section-uid';
  if (isTeilspritzung) {
    sectionIdentifier = 'data-teilspritzung-section-uid';
  }

  let dataSectionID = $('[' + sectionIdentifier + ']');
  dataSectionID.hasNot('input:checked').map(function() {
    spritzung_resetAbschnittData($(this));
  });
  const tableMittel = $('#table-mittel');
  const tableMittelChildren = tableMittel.children(':not(.row-table__head)');
  const wasseraufwandEdit = $('#wasseraufwand-edit');
  const wasseraufwandHaIntern = $('#wasseraufwandHa-intern');

  const abschnitte = {};
  let sumFlaeche = 0;
  let maxWasseraufwand = 0;
  let minWasseraufwand = 0;

    let mittelAbschnitt = {};
  dataSectionID.has('input:checked').map(function() {
    const abschnittBruehe = roundBruehe(Number($(this).find('input.abschnitt-bruehmenge-intern').val()), PSM_BRUEHE_GESAMT_BRUEHE_ABSCHNITT_AUFRUNDEN);
    const abschnittFlaeche = Number($(this).find('input[name="flaeche"]').val());

    // Wasseraufwand überschreiben
    if ($(this).find('input[name="wasseraufwand"]').val() === '' || getCurrentWasseraufwand === true) {
      if (getCurrentWasseraufwand === false && wasseraufwandHaIntern.val() !== '0') {
        $(this).find('input[name="wasseraufwand"]').val(wasseraufwandEdit.val());
      } else {
        const currentWasseraufwand = $(this).find('input[name="wasseraufwand"]').data('current');
        $(this).find('input[name="wasseraufwand"]').val(currentWasseraufwand);
      }
    }

    const abschnittWasseraufwand = Number($(this).find('input[name="wasseraufwand"]').val());
    const abschnittID = Number($(this).attr(sectionIdentifier));
    const kultur = Number($(this).attr('data-kultur'));
    const sorte = Number($(this).attr('data-sorte'));
    const richtlinien = $(this).attr('data-quality-ids');
    const sectionPsmID = Number($(this).attr('data-psm-uid'));

    if (abschnittWasseraufwand > maxWasseraufwand) {
      maxWasseraufwand = abschnittWasseraufwand;
    }
    if (minWasseraufwand === 0) {
      minWasseraufwand = abschnittWasseraufwand;
    } else if (abschnittWasseraufwand < minWasseraufwand) {
      minWasseraufwand = abschnittWasseraufwand;
    }


      let allMittelAbschnittID = [];
    if (tableMittelChildren.length > 0) {
      tableMittelChildren.each(function() {
        const mittelKey = $(this).data('psm-key') + '-' + $(this).data('psm-id');
        const dosisProHl = Number($(this).find('.list-dosisProHl').val());
        if (Number($(this).data('teilspritzung')) === 1 && isTeilspritzung && sectionPsmID === $(this).data('psm-id') || Number($(this).data('teilspritzung')) === 0 && !isTeilspritzung) {
          const mittelmengeAbschnittNeu = roundMittelmenge(abschnittBruehe * dosisProHl);
          const mittelmengeProHaNeu = roundMittelmengeProHa(mittelmengeAbschnittNeu / abschnittFlaeche * 10000);
          if(typeof(mittelAbschnitt[abschnittID]) === 'undefined') {
              mittelAbschnitt[abschnittID] = {};
          }
          mittelAbschnitt[abschnittID][mittelKey] = {
          id: mittelKey,
          name: $(this).find('.list-mittelName').val(),
          dataKey: $(this).data('psm-key'),
          psmID: $(this).data('psm-id'),
          dosisProHl: dosisProHl,
          mittelmenge: mittelmengeAbschnittNeu,
          mittelmengeProHa: mittelmengeProHaNeu,
          sectionID: abschnittID,
          };
        }
      });
    }
    if(typeof(mittelAbschnitt[abschnittID]) !== 'undefined') {
        for (const [key, value] of Object.entries(mittelAbschnitt[abschnittID])) {
            allMittelAbschnittID.push(key);
        }
    }
    else{
        mittelAbschnitt[abschnittID] = {};
    }

    abschnitte[abschnittID] = {
      id: abschnittID,
      flaeche: abschnittFlaeche,
      wasseraufwand: abschnittWasseraufwand,
      kultur: kultur,
      sorte: sorte,
      richtlinien: richtlinien,
      bruehe: abschnittBruehe,
      mittel: mittelAbschnitt[abschnittID],
      alleMittelId: allMittelAbschnittID,
    };

    sumFlaeche += Number($(this).find('input[name="flaeche"]').val());
  });

  // Abschnitt-IDs
  let alleAbschnitteID = [];
  $.each(abschnitte, function(k, v) {
    alleAbschnitteID.push(v.id);
  });
  if (!isTeilspritzung) {
    let hintMessage = '';
    if (minWasseraufwand !== maxWasseraufwand) {
      hintMessage = numberFormat(minWasseraufwand, DECIMAL_PLACES_WASSERAUFWAND, ',') + ' - ' + numberFormat(maxWasseraufwand, DECIMAL_PLACES_WASSERAUFWAND, ',') + ' hl/ha';
    }

    wasseraufwandEdit.parent().next('.hint-message').find('.input-help-message').html(hintMessage);
  }

  // Summe
  let sumMittel = {};
  let allMittelID = [];
  if (tableMittelChildren.length > 0) {
    tableMittelChildren.each(function() {

      if (Number($(this).data('teilspritzung')) === 1 && isTeilspritzung || Number($(this).data('teilspritzung')) === 0 && !isTeilspritzung) {
        const mittelKey = $(this).data('psm-key') + '-' + $(this).data('psm-id');

        sumMittel[mittelKey] = {
          id: mittelKey,
          name: $(this).find('.list-mittelName').val(),
          psmID: $(this).data('psm-id'),
          dataKey: $(this).data('psm-key'),
          dosisProHl: Number($(this).find('.list-dosisProHl').val()),
          mittelmenge: 0.0,
          mittelmengeProHa: 0,
        };

        allMittelID.push(mittelKey);
      }
    });
  }

  // Wasseraufwand berechnet überschreiben
  if (getCurrentWasseraufwand === true) {
    wasseraufwandEdit.val(wasseraufwandEdit.data('current')).parent().next('.hint-message').removeClass('display-none');
    wasseraufwandHaIntern.val('0');
  }

  const summe = {
    flaeche: sumFlaeche,
    bruehe: roundBruehe(Number($('#bruehe-einfach-intern').val())),
    mittel: sumMittel,
    alleMittelId: allMittelID,
  };

  const summeNeu = spritzung_recalculateSumme(summe, alleAbschnitteID, abschnitte, true, isTeilspritzung);

  return {
    abschnitte: abschnitte,
    alleAbschnitteId: alleAbschnitteID,
    summe: summeNeu,
    getCurrentWasseraufwand: getCurrentWasseraufwand,
  };
};

/**
 * spritzung_calc
 * @param state
 * @param action
 */
window.spritzung_calc = function(state, action) {
  switch (action.type) {
      // Brühmenge Summenzeile
    case 'SUMME_BRUEHMENGE_CHANGING': {
      const brueheGesamt = Number(action.bruehmenge);
      const wasseraufwandHaCalc = brueheGesamt / state.summe.flaeche * 10000;
      const bruehmengeStammdatenGesamt = state.alleAbschnitteId.map(idAbschnitt => state.abschnitte[idAbschnitt]).map(a => wasseraufwandHaCalc * a.flaeche / 10000).reduce((a, b) => a + b, 0.0);

      const abschnitteNeu = state.alleAbschnitteId.map(idAbschnitt => state.abschnitte[idAbschnitt]).map(a => {
        const brueheAbschnittStammdaten = wasseraufwandHaCalc * a.flaeche / 10000;
        // abrunden
        const brueheAbschnittNeu = roundBruehe(brueheAbschnittStammdaten / bruehmengeStammdatenGesamt * brueheGesamt, PSM_BRUEHE_GESAMT_BRUEHE_ABSCHNITT_AUFRUNDEN);

        return {
          ...a,
          bruehe: brueheAbschnittNeu,
          mittel: a.alleMittelId.map(mittelId => a.mittel[mittelId]).map(mittel => {
            //abrunden
            const mittelmengeAbschnittNeu = roundMittelmenge(brueheAbschnittNeu * mittel.dosisProHl, PSM_BRUEHE_GESAMT_MITTELMENGE_ABSCHNITT_AUFRUNDEN);
            // rundungshölle: 3.528*10000/5880 != 3.528/5880 * 10000
            const mittelmengeProHaNeu = roundMittelmengeProHa(mittelmengeAbschnittNeu * 10000 / a.flaeche);
            return {
              ...mittel,
              mittelmenge: mittelmengeAbschnittNeu,
              mittelmengeProHa: mittelmengeProHaNeu,
            };

          }).reduce((alleMittel, m) => ({
            ...alleMittel,
            [m.id]: m,
          }), {}),

        };

      }).reduce((alle, abschnitt) => ({...alle, [abschnitt.id]: abschnitt}), {});

      let savedBruehe = false;
      if (action.savedBruehe) {
        savedBruehe = true;
      }

      const calcBruehmenge = {
        ...state,
        summe: spritzung_recalculateSumme(state.summe, state.alleAbschnitteId, abschnitteNeu, savedBruehe),
        abschnitte: abschnitteNeu,
      };

      // Brühe-Einfach
      if (typeof action.noCalc_brueheEinfach === 'undefined') {
        $('#bruehe-einfach').val(roundBrueheGui(brueheGesamt));
      }
      $('#bruehe-einfach-intern').val(roundBruehe(calcBruehmenge.summe.bruehe));

      // Calc Brühe-Effektiv
      const calcBrueheEffektiv = calcBruehmenge.summe.bruehe / Number(action.konzentrationFaktor);
      if (typeof action.noCalc_brueheEffektiv === 'undefined') {
        $('#bruehe-effektiv').val(roundBrueheGui(calcBrueheEffektiv));
      }
      $('#bruehe-effektiv-intern').val(roundBruehe(calcBrueheEffektiv));

      $('#wasseraufwand-edit').val(roundWasseraufwand(wasseraufwandHaCalc)).data('current', roundWasseraufwand(wasseraufwandHaCalc));
      if (!isNaN(wasseraufwandHaCalc)) {
        if (action.isReset === true) {
          $('#wasseraufwandHa-intern').val('0');
        } else {
          $('#wasseraufwandHa-intern').val(roundWasseraufwand(wasseraufwandHaCalc));
        }
      }

      // Map Brühe auf alle Abschnitte
      calcBruehmenge.alleAbschnitteId.map(idAbschnitt => calcBruehmenge.abschnitte[idAbschnitt]).map(a => {
        const section = $('div[data-section-uid="' + a.id + '"]');
        const sectionTeilspritzung = $('div[data-teilspritzung-section-uid="' + a.id + '"]');
        if (typeof (sectionTeilspritzung) !== 'undefined') {
          sectionTeilspritzung.find('input.abschnitt-bruehmenge').val(roundBrueheGui(a.bruehe));
          sectionTeilspritzung.find('input.abschnitt-bruehmenge-intern').val(roundBruehe(a.bruehe, PSM_BRUEHE_GESAMT_BRUEHE_ABSCHNITT_AUFRUNDEN));
          if (state.getCurrentWasseraufwand === false && $('#wasseraufwandHa-intern').val() !== '0') {
            sectionTeilspritzung.find('input[name="wasseraufwand"]').val(wasseraufwandHaCalc);
          }
        }

        section.find('input.abschnitt-bruehmenge').val(roundBrueheGui(a.bruehe));
        section.find('input.abschnitt-bruehmenge-intern').val(roundBruehe(a.bruehe, PSM_BRUEHE_GESAMT_BRUEHE_ABSCHNITT_AUFRUNDEN));
        if (state.getCurrentWasseraufwand === false && $('#wasseraufwandHa-intern').val() !== '0') {
          section.find('input[name="wasseraufwand"]').val(wasseraufwandHaCalc);
        }
      });

      spritzung_recalcRowMittel();
      spritzung_recalcRowMittel(true);
      spritzung_bindSetAdditionalText();

      return calcBruehmenge;
    }

      // Wasseraufwand Summenzeile
    case 'SUMME_WASSERAUFWAND_CHANGING': {
      const bruehmengeGesamt = state.alleAbschnitteId.map(idAbschnitt => state.abschnitte[idAbschnitt]).map(a => a.wasseraufwand * a.flaeche / 10000).reduce((a, b) => a + b, 0.0);
      let wasseraufwandHaCalc = 0;
      if (state.summe.flaeche > 0) {
        wasseraufwandHaCalc = state.alleAbschnitteId.map(idAbschnitt => state.abschnitte[idAbschnitt]).map(a => a.wasseraufwand * a.flaeche).reduce((a, b) => a + b, 0.0) / state.summe.flaeche;
      }

      const abschnitteNeu = state.alleAbschnitteId.map(idAbschnitt => state.abschnitte[idAbschnitt]).map(a => {
        const brueheAbschnittStammdaten = a.wasseraufwand * a.flaeche / 10000;
        // abrunden
        const brueheAbschnittNeu = roundBruehe(brueheAbschnittStammdaten, PSM_BRUEHE_GESAMT_BRUEHE_ABSCHNITT_AUFRUNDEN);

        return {
          ...a,
          bruehe: brueheAbschnittNeu,
          mittel: a.alleMittelId.map(mittelId => a.mittel[mittelId]).map(mittel => {
            //abrunden
            const mittelmengeAbschnittNeu = roundMittelmenge(brueheAbschnittNeu * mittel.dosisProHl, PSM_BRUEHE_GESAMT_MITTELMENGE_ABSCHNITT_AUFRUNDEN);
            // rundungshölle: 3.528*10000/5880 != 3.528/5880 * 10000
            const mittelmengeProHaNeu = roundMittelmengeProHa(mittelmengeAbschnittNeu * 10000 / a.flaeche);
            return {
              ...mittel,
              mittelmenge: mittelmengeAbschnittNeu,
              mittelmengeProHa: mittelmengeProHaNeu,
            };

          }).reduce((alleMittel, m) => ({
            ...alleMittel,
            [m.id]: m,
          }), {}),

        };

      }).reduce((alle, abschnitt) => ({...alle, [abschnitt.id]: abschnitt}), {});

      let savedBruehe = false;
      if (action.savedBruehe) {
        savedBruehe = true;
      }

      const calcBruehmenge = {
        ...state,
        summe: spritzung_recalculateSumme(state.summe, state.alleAbschnitteId, abschnitteNeu, savedBruehe),
        abschnitte: abschnitteNeu,
      };

      // Brühe-Einfach
      if (typeof action.noCalc_brueheEinfach === 'undefined') {
        $('#bruehe-einfach').val(roundBrueheGui(bruehmengeGesamt));
      }
      $('#bruehe-einfach-intern').val(roundBruehe(calcBruehmenge.summe.bruehe));

      // Calc Brühe-Effektiv
      const calcBrueheEffektiv = calcBruehmenge.summe.bruehe / Number(action.konzentrationFaktor);
      if (typeof action.noCalc_brueheEffektiv === 'undefined') {
        $('#bruehe-effektiv').val(roundBrueheGui(calcBrueheEffektiv));
      }
      $('#bruehe-effektiv-intern').val(roundBruehe(calcBrueheEffektiv));

      const wasseraufwandEdit = $('#wasseraufwand-edit');
      if (wasseraufwandEdit.val() !== '' && $('#wasseraufwandHa-intern').val() === '0') {
        let wasseraufwandRound = roundWasseraufwand(wasseraufwandHaCalc);
        wasseraufwandEdit.val(wasseraufwandRound).data('current', wasseraufwandRound);
        if (!isNaN(wasseraufwandRound)) {
          $('#wasseraufwandHa-intern').val(wasseraufwandRound);
        }
      }

      // Map Brühe auf alle Abschnitte
      calcBruehmenge.alleAbschnitteId.map(idAbschnitt => calcBruehmenge.abschnitte[idAbschnitt]).map(a => {
        const section = $('div[data-section-uid="' + a.id + '"]');

        section.find('input.abschnitt-bruehmenge').val(roundBrueheGui(a.bruehe));
        section.find('input.abschnitt-bruehmenge-intern').val(roundBruehe(a.bruehe, PSM_BRUEHE_GESAMT_BRUEHE_ABSCHNITT_AUFRUNDEN));

        const sectionTeilspritzung = $('div[data-teilspritzung-section-uid="' + a.id + '"]');

        sectionTeilspritzung.find('input.abschnitt-bruehmenge').val(roundBrueheGui(a.bruehe));
        sectionTeilspritzung.find('input.abschnitt-bruehmenge-intern').val(roundBruehe(a.bruehe, PSM_BRUEHE_GESAMT_BRUEHE_ABSCHNITT_AUFRUNDEN));
      });

      spritzung_recalcRowMittel();
      spritzung_recalcRowMittel(true);
      spritzung_bindSetAdditionalText();

      return calcBruehmenge;
    }

      // Konzentrationsfaktor summenzeile
    case 'SUMME_KONZENTRATION_FAKTOR_CHANGING': {
      // Calc Brühe-Effektiv
      const calcBrueheEffektiv = Number(action.bruehmenge) / Number(action.konzentrationFaktor);
      $('#bruehe-effektiv').val(roundBrueheGui(calcBrueheEffektiv));
      $('#bruehe-effektiv-intern').val(calcBrueheEffektiv);

      spritzung_recalcRowMittel();
      spritzung_recalcRowMittel(true);

      return {
        brueheEffektiv: calcBrueheEffektiv,
      };
    }

      // dosis pro hl summenzeile
    case 'SUMME_DOSIS_PRO_HL_CHANGING': {
      const mittelIdAction = action.mittelKey + '-' + action.mittelId;
      const dosisProHlNeu = Number(action.dosisProHl);
      $('input.dosisProHl').val(dosisProHlNeu);

      if (!state.summe.mittel[mittelIdAction]) {
        state.summe.mittel[mittelIdAction] = {
          id: mittelIdAction,
          name: action.mittelName,
          dataKey: action.mittelKey,
          dosisProHl: 0.0,
          mittelmenge: 0.0,
          mittelmengeProHa: 0,
        };

        state.summe.alleMittelId.push(mittelIdAction);
      }

      const abschnitteNeu = state.alleAbschnitteId.map(idAbschnitt => state.abschnitte[idAbschnitt]).map(a => {
        if (!action.isTeilspritzung || (action.isTeilspritzung && $('.third-level[data-teilspritzung-section-uid="' + a.id + '"][data-psm-uid="' + action.mittelId + '"]').find('input:checked').length > 0)) {
          if (!a.alleMittelId.includes(mittelIdAction)) {
            a.alleMittelId.push(mittelIdAction);
            a.mittel[mittelIdAction] = {
              id: mittelIdAction,
              name: action.mittelName,
              dataKey: action.mittelKey,
              dosisProHl: 0.0,
              mittelmenge: 0.0,
              mittelmengeProHa: 0,
            };
          }
        }

        return {
          ...a,
          mittel: a.alleMittelId.map(mittelId => a.mittel[mittelId]).map(mittel => {
            if (mittel.id !== mittelIdAction) {
              return {...mittel};
            }

            // abrunden
            const mittelmengeNeu = roundMittelmenge(a.bruehe * dosisProHlNeu, PSM_DOSIS_PRO_HL_GESAMT_MITTELMENGE_ABSCHNITT_AUFRUNDEN);
            const mittelmengeProHaNeu = roundMittelmengeProHa(mittelmengeNeu * 10000 / a.flaeche);

            return {
              ...mittel,
              dosisProHl: roundMittelmengeProHl(mittelmengeNeu / a.bruehe), // dosis pro hl neu berechnen
              mittelmenge: mittelmengeNeu,
              mittelmengeProHa: mittelmengeProHaNeu,
            };

          }).reduce((alleMittel, m) => ({
            ...alleMittel,
            [m.id]: m,
          }), {}),
        };
      }).reduce((alle, abschnitt) => ({...alle, [abschnitt.id]: abschnitt}), {});

      const summeNeu = spritzung_recalculateSumme(state.summe, state.alleAbschnitteId, abschnitteNeu, false, action.isTeilspritzung);
      let sumBrueheTeilspritzungNeu = [];
      if (action.isTeilspritzung) {
        for (const [, value] of Object.entries(abschnitteNeu)) {
          for (const [key2] of Object.entries(value.mittel)) {
            if (typeof sumBrueheTeilspritzungNeu[key2] === 'undefined') {
              sumBrueheTeilspritzungNeu[key2] = value.bruehe;
            } else {
              sumBrueheTeilspritzungNeu[key2] += value.bruehe;
            }
          }
        }
      }

      const calcedData = {
        ...state,
        abschnitte: abschnitteNeu,
        summe: {
          ...summeNeu,
          mittel: {
            ...summeNeu.mittel,
            [mittelIdAction]: {
              ...summeNeu.mittel[mittelIdAction],
              dosisProHl: dosisProHlNeu,
            },
          },
        },
      };

      if (action.previewData === true) {
        // Mittelmenge
        $('input.sumMittelmengeGui').val(roundMittelmengeGui(calcedData.summe.mittel[mittelIdAction].mittelmenge));
        $('input.sumMittelmenge').val(calcedData.summe.mittel[mittelIdAction].mittelmenge);

        // Mittelmenge pro ha
        $('input.sumMittelmengeProHaGui').val(roundMittelmengeProHaGui(calcedData.summe.mittel[mittelIdAction].mittelmengeProHa));
        $('input.sumMittelmengeProHa').val(calcedData.summe.mittel[mittelIdAction].mittelmengeProHa);
      }

      return calcedData;
    }

      // mittelmenge summenzeile
    case 'SUMME_MITTELMENGE_CHANGING': {
      const mittelIdAction = action.mittelKey + '-' + action.mittelId;
      const mittelmenge = roundMittelmengeGui(Number(action.mittelmenge));
      if (typeof action.noCalc_sumMittelmenge === 'undefined') {
        $('input.sumMittelmengeGui').val(mittelmenge);
      }
      const brueheGesamt = state.alleAbschnitteId.map(idAbschnitt => state.abschnitte[idAbschnitt]).reduce((a, b) => {
          return a + b.bruehe;
      }, 0.0);

      // abrunden
      const dosisProHlNeu = roundMittelmengeProHl(mittelmenge / brueheGesamt, PSM_MITTELMENGE_GESAMT_DOSIS_PRO_HL_AUFRUNDEN);

      if (!state.summe.mittel[mittelIdAction]) {
        state.summe.mittel[mittelIdAction] = {
          id: mittelIdAction,
          name: action.mittelName,
          dataKey: action.mittelKey,
          dosisProHl: 0.0,
          mittelmenge: 0.0,
          mittelmengeProHa: 0,
        };

        state.summe.alleMittelId.push(mittelIdAction);
      }

      const abschnitteNeu = state.alleAbschnitteId.map(idAbschnitt => state.abschnitte[idAbschnitt]).map(a => {
        if (!a.alleMittelId.includes(mittelIdAction)) {
          a.alleMittelId.push(mittelIdAction);

          a.mittel[mittelIdAction] = {
            id: mittelIdAction,
            name: action.mittelName,
            dataKey: action.mittelKey,
            dosisProHl: 0.0,
            mittelmenge: 0.0,
            mittelmengeProHa: 0,
          };
        }

        return {
          ...a,
          mittel: a.alleMittelId.map(mittelId => a.mittel[mittelId]).map(mittel => {
            if (mittel.id !== mittelIdAction) {
              return {...mittel};
            }

            const mittelmengeNeu = roundMittelmenge(a.bruehe * dosisProHlNeu);
            const mittelmengeProHaNeu = roundMittelmengeProHa(mittelmengeNeu * 10000 / a.flaeche);

            return {
              ...mittel,
              dosisProHl: dosisProHlNeu,
              mittelmenge: mittelmengeNeu,
              mittelmengeProHa: mittelmengeProHaNeu,
            };

          }).reduce((alleMittel, m) => ({
            ...alleMittel,
            [m.id]: m,
          }), {}),
        };
      }).reduce((alle, abschnitt) => ({...alle, [abschnitt.id]: abschnitt}), {});

      const summeNeu = spritzung_recalculateSumme(state.summe, state.alleAbschnitteId, abschnitteNeu);

      const calcedData = {
        ...state,
        abschnitte: abschnitteNeu,
        summe: {
          ...summeNeu,
          mittel: {
            ...summeNeu.mittel,
            [mittelIdAction]: {
              ...summeNeu.mittel[mittelIdAction],
              dosisProHl: dosisProHlNeu,
            },
          },
        },
      };

      if (action.previewData === true) {
        // Dosis pro HL
        $('input.dosisProHlGui').val(roundMittelmengeGui(calcedData.summe.mittel[mittelIdAction].dosisProHl));
        $('input.dosisProHl').val(calcedData.summe.mittel[mittelIdAction].dosisProHl);

        // Mittelmenge pro ha
        $('input.sumMittelmengeProHaGui').val(roundMittelmengeProHaGui(calcedData.summe.mittel[mittelIdAction].mittelmengeProHa));
        $('input.sumMittelmengeProHa').val(calcedData.summe.mittel[mittelIdAction].mittelmengeProHa);
      }

      return calcedData;
    }

      // mittelmenge pro ha summenzeile
    case 'SUMME_MITTELMENGE_PRO_HA_CHANGING': {
      const mittelIdAction = action.mittelKey + '-' + action.mittelId;
      const mittelmengeProHa = roundMittelmengeProHaGui(Number(action.mittelmengeProHa));
      $('input.sumMittelmengeProHa').val(mittelmengeProHa);

      const abschnitte = state.alleAbschnitteId.map(idAbschnitt => state.abschnitte[idAbschnitt]);
      const flaecheGesamt = abschnitte.reduce((a, b) => {
        if (typeof b.mittel[mittelIdAction] === 'undefined') {
          return a + 0;
        } else {
          return a + b.flaeche;
        }
      }, 0.0);
      const brueheGesamt = abschnitte.reduce((a, b) => {
          return a + b.bruehe;
      }, 0.0);
      if (brueheGesamt === 0.0) {
        return state;
      }

      let dosisProHlNeu;
      if (PSM_MITTELMENGE_PRO_HA_KLEINSTE_DOSIS_PRO_HL_FINDEN && wasserbedarfIdentisch(abschnitte)) {
        //abrunden
        dosisProHlNeu = roundMittelmengeProHl(findDosisProHl(state.alleAbschnitteId.map(idAbschnitt => state.abschnitte[idAbschnitt]), mittelmengeProHa), PSM_MITTELMENGE_PRO_HA_DOSIS_PRO_HL_AUFRUNDEN);
      } else {
        //abrunden
        dosisProHlNeu = roundMittelmengeProHl(mittelmengeProHa * flaecheGesamt / brueheGesamt / 10000, PSM_MITTELMENGE_PRO_HA_DOSIS_PRO_HL_AUFRUNDEN);
      }

      if (!state.summe.mittel[mittelIdAction]) {
        state.summe.mittel[mittelIdAction] = {
          id: mittelIdAction,
          name: action.mittelName,
          dataKey: action.mittelKey,
          dosisProHl: 0.0,
          mittelmenge: 0.0,
          mittelmengeProHa: 0,
        };

        state.summe.alleMittelId.push(mittelIdAction);
      }

      const abschnitteNeu = state.alleAbschnitteId.map(idAbschnitt => state.abschnitte[idAbschnitt]).map(a => {
        if (!action.isTeilspritzung || (action.isTeilspritzung && $('.third-level[data-teilspritzung-section-uid="' + a.id + '"][data-psm-uid="' + action.mittelId + '"]').find('input:checked').length > 0)) {
          if (!a.alleMittelId.includes(mittelIdAction)) {
            a.alleMittelId.push(mittelIdAction);

            a.mittel[mittelIdAction] = {
              id: mittelIdAction,
              name: action.mittelName,
              dataKey: action.mittelKey,
              dosisProHl: 0.0,
              mittelmenge: 0.0,
              mittelmengeProHa: 0,
            };
          }
        }

        return {
          ...a,
          mittel: a.alleMittelId.map(mittelId => a.mittel[mittelId]).map(mittel => {
            if (mittel.id !== mittelIdAction) {
              return {...mittel};
            }

            //abrunden
            const mittelmengeNeu = roundMittelmenge(dosisProHlNeu * a.bruehe, PSM_MITTELMENGE_PRO_HA_MITTELMENGE_ABSCHNITT_AUFRUNDEN);
            const mittelmengeProHaNeu = roundMittelmengeProHa(mittelmengeNeu * 10000 / a.flaeche);

            return {
              ...mittel,
              dosisProHl: dosisProHlNeu,
              mittelmenge: mittelmengeNeu,
              mittelmengeProHa: mittelmengeProHaNeu,
            };

          }).reduce((alleMittel, m) => ({
            ...alleMittel,
            [m.id]: m,
          }), {}),

        };

      }).reduce((alle, abschnitt) => ({...alle, [abschnitt.id]: abschnitt}), {});
      const summeNeu = spritzung_recalculateSumme(state.summe, state.alleAbschnitteId, abschnitteNeu, false, action.isTeilspritzung);
      const calcedData = {
        ...state,
        abschnitte: abschnitteNeu,
        summe: {
          ...summeNeu,
          mittel: {
            ...summeNeu.mittel,
            [mittelIdAction]: {
              ...summeNeu.mittel[mittelIdAction],
              dosisProHl: dosisProHlNeu,
            },
          },
        },
      };

      if (action.previewData === true) {
        // Dosis pro HL
        $('input.dosisProHlGui').val(roundMittelmengeGui(calcedData.summe.mittel[mittelIdAction].dosisProHl));
        $('input.dosisProHl').val(calcedData.summe.mittel[mittelIdAction].dosisProHl);

        // Mittelmenge
        $('input.sumMittelmengeGui').val(roundMittelmengeGui(calcedData.summe.mittel[mittelIdAction].mittelmenge));
        $('input.sumMittelmenge').val(calcedData.summe.mittel[mittelIdAction].mittelmenge);
      }

      return calcedData;
    }

      // abschnitt bruehmenge
    case 'ABSCHNITT_BRUEHMENGE_CHANGING': {
      const idAbschnitt = action.idAbschnitt;
      const brueheAbschnittNeu = Number(action.bruehmenge) ?? 0.0;
      let abschnitteTeilspritzung;
      const teilspritzung = $('*[data-teilspritzung-section-uid="' + idAbschnitt + '"]');
      // ggf. auch bei Teilspritzung anpassen
      if (typeof (teilspritzung.find('input.abschnitt-bruehmenge')) !== 'undefined') {
        abschnitteTeilspritzung = spritzung_buildAbschnittData(false, true);
        teilspritzung.find('input.abschnitt-bruehmenge').val(brueheAbschnittNeu);
        teilspritzung.find('input.abschnitt-bruehmenge-intern').val(brueheAbschnittNeu);
      }
      const abschnitteNeu = state.alleAbschnitteId.map(idAbschnitt => state.abschnitte[idAbschnitt]).map(a => a.id !== idAbschnitt ? ({...a}) : ({
        ...a,
        bruehe: brueheAbschnittNeu,
        mittel: a.alleMittelId.map(mittelId => a.mittel[mittelId]).map(mittel => {
          const mittelmengeAbschnittNeu = roundMittelmenge(brueheAbschnittNeu * mittel.dosisProHl);
          const mittelmengeProHaNeu = roundMittelmengeProHa(mittelmengeAbschnittNeu * 10000 / a.flaeche);

          return {
            ...mittel,
            mittelmenge: mittelmengeAbschnittNeu,
            mittelmengeProHa: mittelmengeProHaNeu,
          };
        }).reduce((alleMittel, m) => ({
          ...alleMittel,
          [m.id]: m,
        }), {}),
      })).reduce((alle, abschnitt) => ({...alle, [abschnitt.id]: abschnitt}), {});

      const changingData = {
        ...state,
        summe: spritzung_recalculateSumme(state.summe, state.alleAbschnitteId, abschnitteNeu),
        abschnitte: abschnitteNeu,
      };

      // Brühe-Einfach
      $('#bruehe-einfach').val(roundBrueheGui(changingData.summe.bruehe));
      $('#bruehe-einfach-intern').val(changingData.summe.bruehe);

      // Calc Brühe-Effektiv
      const calcBrueheEffektiv = changingData.summe.bruehe / Number(action.konzentrationFaktor);
      $('#bruehe-effektiv').val(roundBrueheGui(calcBrueheEffektiv));
      $('#bruehe-effektiv-intern').val(calcBrueheEffektiv);

      // Map Brühe auf alle Abschnitte
      changingData.alleAbschnitteId.map(idAbschnitt => changingData.abschnitte[idAbschnitt]).map(a => {
        const section = $('div[data-section-uid="' + a.id + '"]');

        if (typeof action.noCalc_abschnittBruehmenge === 'undefined') {
          section.find('input.abschnitt-bruehmenge').val(roundBrueheGui(a.bruehe));
        }
        section.find('input.abschnitt-bruehmenge-intern').val(roundBruehe(a.bruehe, PSM_BRUEHE_GESAMT_BRUEHE_ABSCHNITT_AUFRUNDEN));
      });

      spritzung_recalcRowMittel();
      spritzung_recalcRowMittel(true);

      return changingData;
    }

      // Brühe aus Stammdaten holen und mittel anhand dosis pro hl neu verteile
    case 'RESET_BRUEHE': {
      const abschnitteNeu = state.alleAbschnitteId.map(idAbschnitt => state.abschnitte[idAbschnitt]).map(a => {
        const brueheAbschnittStammdaten = roundBruehe(a.wasseraufwand * a.flaeche / 10000);
        return {
          ...a,
          bruehe: brueheAbschnittStammdaten,
          mittel: a.alleMittelId.map(mittelId => a.mittel[mittelId]).map(mittel => {
            const mittelmengeAbschnittNeu = roundMittelmenge(brueheAbschnittStammdaten * mittel.dosisProHl, PSM_BRUEHE_GESAMT_MITTELMENGE_ABSCHNITT_AUFRUNDEN);
            const mittelmengeProHaNeu = roundMittelmengeProHa(mittelmengeAbschnittNeu / a.flaeche * 10000);
            return {
              ...mittel,
              mittelmenge: mittelmengeAbschnittNeu,
              mittelmengeProHa: mittelmengeProHaNeu,
            };

          }).reduce((alleMittel, m) => ({
            ...alleMittel,
            [m.id]: m,
          }), {}),

        };

      }).reduce((alle, abschnitt) => ({...alle, [abschnitt.id]: abschnitt}), {});

      let savedBruehe = false;
      if (action.firstLoad) {
        savedBruehe = true;
      }

      const calcBruehmenge = {
        ...state,
        summe: spritzung_recalculateSumme(state.summe, state.alleAbschnitteId, abschnitteNeu, savedBruehe),
        abschnitte: abschnitteNeu,
      };

      // Brühe 1-fach
      spritzung_calc(calcBruehmenge, {
        type: 'SUMME_BRUEHMENGE_CHANGING',
        bruehmenge: calcBruehmenge.summe.bruehe,
        konzentrationFaktor: $('#konzentration-faktor').val(),
        savedBruehe: savedBruehe,
        isReset: true,
      });

      //spritzung_recalcRowMittel();

      return calcBruehmenge;
    }
  }
};

/**
 * spritzung_recalcRowMittel
 */
window.spritzung_recalcRowMittel = function(isTeilspritzung = false) {
  const abschnittData = spritzung_buildAbschnittData(false, isTeilspritzung);
  if ($.isEmptyObject(abschnittData.abschnitte) === false) {
    // Mittelsumme
    $.each(abschnittData.summe.mittel, function(key, value) {
      const mittelRow = $('#table-mittel').find('*[data-psm-id="' + value.psmID + '"][data-psm-key="' + value.dataKey + '"]');
      if (mittelRow.length > 0) {
        // Template
        let template = mittelRow.html();

        // Einheit
        const einheitName = mittelRow.find('.list-einheitName').val();
        template = template.replace(new RegExp('__MITTELMENGE_GUI__', 'g'), numberFormat(value.mittelmenge, DECIMAL_PLACES_MITTELMENGE_GUI, ',', '.') + ' ' + einheitName);
        template = template.replace(new RegExp('__MITTELMENGE_HA_GUI__', 'g'), numberFormat(value.mittelmengeProHa, DECIMAL_PLACES_MITTELMENGE_PRO_HA_GUI, ',', '.') + ' ' + einheitName);

        mittelRow.html(template);

        mittelRow.find('.list-mittelmengeGui').html(numberFormat(value.mittelmenge, DECIMAL_PLACES_MITTELMENGE_GUI, ',', '.') + ' ' + einheitName).removeClass('display-none');
        mittelRow.find('.list-mittelmengeHaGui').html(numberFormat(value.mittelmengeProHa, DECIMAL_PLACES_MITTELMENGE_GUI, ',', '.') + ' ' + einheitName).removeClass('display-none');
      }
    });
    // Abschnittsdaten
    $.each(abschnittData.abschnitte, function(key, value) {
      $.each(value.mittel, function(keyMittel, valueMittel) {
        let mittelAbschnittIdentifier = '.table-mittel-abschnitt';
        let sectionIdentifier = 'data-section-uid';
        let psmID = 0;
        if (isTeilspritzung) {
          mittelAbschnittIdentifier = '.table-mittel-abschnitt-teilspritzung';
          sectionIdentifier = 'data-teilspritzung-section-uid';
        }

        const mittelAbschnittRow = $(mittelAbschnittIdentifier).find('*[' + sectionIdentifier + '="' + valueMittel.sectionID + '"][data-psm-id="' + valueMittel.psmID + '"][data-psm-key="' + valueMittel.dataKey + '"]');
        if (mittelAbschnittRow.length > 0) {

          psmID = $(mittelAbschnittRow).data('psmId');
          if (isTeilspritzung && Number(valueMittel.psmID) !== Number(psmID)) {
            mittelAbschnittRow.remove();
          }
          // Template
          let template = mittelAbschnittRow.html();

          // Einheit
          const einheitName = mittelAbschnittRow.find('.listAbschnitt-einheitName').val();
          template = template.replace(new RegExp('__MITTELMENGE_GUI__', 'g'), numberFormat(valueMittel.mittelmenge, DECIMAL_PLACES_MITTELMENGE_GUI, ',', '.') + ' ' + einheitName);
          template = template.replace(new RegExp('__MITTELMENGE__', 'g'), valueMittel.mittelmenge, DECIMAL_PLACES_MITTELMENGE);

          template = template.replace(new RegExp('__MITTELMENGE_HA_GUI', 'g'), numberFormat(valueMittel.mittelmengeProHa, DECIMAL_PLACES_MITTELMENGE_GUI, ',', '.') + ' ' + einheitName);
          template = template.replace(new RegExp('__MITTELMENGE_HA__', 'g'), valueMittel.mittelmengeProHa, DECIMAL_PLACES_MITTELMENGE_PRO_HA);

          mittelAbschnittRow.html(template);

          mittelAbschnittRow.find('.list-mittelmengeGui').html(numberFormat(valueMittel.mittelmenge, DECIMAL_PLACES_MITTELMENGE_GUI, ',', '.') + ' ' + einheitName).removeClass('display-none');
          mittelAbschnittRow.find('.list-mittelmengeHaGui').html(numberFormat(valueMittel.mittelmengeProHa, DECIMAL_PLACES_MITTELMENGE_GUI, ',', '.') + ' ' + einheitName).removeClass('display-none');
        } else {
          // Abschnittsmittel neu erstellens

          if ((isTeilspritzung && Number(valueMittel.psmID) === Number(psmID)) || !isTeilspritzung) {
            // Mittelrow
            const mittelRow = $('#table-mittel').find('*[data-psm-id="' + valueMittel.psmID + '"][data-psm-key="' + valueMittel.dataKey + '"]');
            const detailTable = $('.tree-item[' + sectionIdentifier + '="' + valueMittel.sectionID + '"]').find('div' + mittelAbschnittIdentifier);

            // Template
            let template = $('#mittel-abschnitt-row').html();

            // Einheit
            const einheitName = mittelRow.find('.list-einheitName').val();

            template = template.replace(new RegExp('__KEY__', 'g'), 'NEW_' + rand());
            template = template.replace(new RegExp('__SECTION_ID__', 'g'), valueMittel.sectionID);
            template = template.replace(new RegExp('__PSM_ID__', 'g'), valueMittel.psmID);
            template = template.replace(new RegExp('__PSM_KEY__', 'g'), valueMittel.dataKey);
            template = template.replace(new RegExp('__ROW_ID__', 'g'), mittelRow.data('row-key'));
            template = template.replace(new RegExp('__PSM_NAME__', 'g'), valueMittel.name);
            template = template.replace(new RegExp('__DOSIS_HL__', 'g'), valueMittel.dosisProHl);
            template = template.replace(new RegExp('__DOSIS_EINHEIT_NAME__', 'g'), einheitName);
            template = template.replace(new RegExp('__PSM_WIRKUNG__', 'g'), mittelRow.find('.list-wirkung').text());
            template = template.replace(new RegExp('__EMPFEHLUNG_TEXT__', 'g'), mittelRow.find('.list-empfehlung').text());
            template = template.replace(new RegExp('__DOSIS_HL_GUI__', 'g'), mittelRow.find('.list-dosis').text());
            template = template.replace(new RegExp('__MITTELMENGE_GUI__', 'g'), numberFormat(valueMittel.mittelmenge, DECIMAL_PLACES_MITTELMENGE_GUI, ',', '.') + ' ' + einheitName);
            template = template.replace(new RegExp('__MITTELMENGE__', 'g'), valueMittel.mittelmenge, DECIMAL_PLACES_MITTELMENGE);
            template = template.replace(new RegExp('__MITTELMENGE_HA_GUI', 'g'), numberFormat(valueMittel.mittelmengeProHa, DECIMAL_PLACES_MITTELMENGE_GUI, ',', '.') + ' ' + einheitName);
            template = template.replace(new RegExp('__MITTELMENGE_HA__', 'g'), valueMittel.mittelmengeProHa, DECIMAL_PLACES_MITTELMENGE_PRO_HA);
            template = template.replace(new RegExp('__DOSIS_CLASS__', 'g'), '');
            template = template.replace(new RegExp('__MITTELMENGE_HA_CLASS__', 'g'), '');

            // Create new line or replace
            const mittelAbschnittRow = detailTable.find('div[data-section-uid="' + valueMittel.sectionID + '"][data-psm-id="' + valueMittel.psmID + '"][data-psm-key="' + valueMittel.dataKey + '"]');
            if (mittelAbschnittRow.length > 0) {
              mittelAbschnittRow.replaceWith(template);
            } else {
              detailTable.append(template);
            }

            // overwrite values
            const newMittelAbschnittRow = detailTable.find('div[data-section-uid="' + valueMittel.sectionID + '"][data-psm-id="' + valueMittel.psmID + '"][data-psm-key="' + valueMittel.dataKey + '"]');
            newMittelAbschnittRow.find('.list-mittelmengeGui').html(numberFormat(valueMittel.mittelmenge, DECIMAL_PLACES_MITTELMENGE_GUI, ',', '.') + ' ' + einheitName).removeClass('display-none');
            newMittelAbschnittRow.find('.list-mittelmengeHaGui').html(numberFormat(valueMittel.mittelmengeProHa, DECIMAL_PLACES_MITTELMENGE_GUI, ',', '.') + ' ' + einheitName).removeClass('display-none');
          }
        }
      });
    });
  }

  return true;
};

/**
 * Open Mittel-Dialog
 * @param element
 * @param recordID
 * @returns {boolean}
 */
window.spritzung_openMittelDialog = function(element, recordID) {
  ajaxDialog(BASE_PATH + 'ajax/dialog/aufzeichnungen/ajax.addMittelSpritzung', 500, {
    post_data: {
      data: $(element).closest('div.row').find('input').serializeObject(),
      recordID: recordID,
      additionalData: getCultureQuality(),
    },
  });
  return false;
};

/**
 * spritzung_removeMittel
 * @param element
 */
window.spritzung_removeMittel = function(element) {
  const elementDiv = $(element).closest('div.row');

  // Aktuelle Zeile entfernen
  $(element).closest('div.row').remove();
  $('#list_aufzeichnungFlaechenSpritzung').find('div.table-mittel-abschnitt').find('div[data-psm-id="' + elementDiv.data('psm-id') + '"][data-psm-key="' + elementDiv.data('psm-key') + '"]').remove();
  $('.accordion__item[data-step="2a-' + elementDiv.data('psm-key') + '-' + elementDiv.data('psm-id') + '"]').remove();

  spritzung_removeLastStep();
  spritzung_bindSetAdditionalText();
};

/**
 * spritzung_bindAddMittel
 */
window.spritzung_bindAddMittel = function() {
  initTooltip();

  const psmRestritctionUsePeriod = $('.psm_restriction_use_period');
  psmRestritctionUsePeriod.each(function() {
    spritzung_changeZeitspanne($(this));
  });
  psmRestritctionUsePeriod.on('change', function() {
    spritzung_changeZeitspanne($(this));
  });

  $('input, select, textarea').keypress(function(event) {
    // 10 is for mac
    if (event.keyCode === 13 || event.keyCode === 10) {
      event.preventDefault();
      $(this).closest('div').next().find('input, select, textarea').focus();
    }
  });

  const row = $('#mittel-psmID').closest('div.psm-mittel-row');
  spritzung_bindIndicationSelect(row, row.find('input.psm_mittel_uid').val(), row.find('input.psm_recordID').val(), row.find('input.data_key').val());
  spritzung_bindUsePeriodSelect();

  // Empfehlung übernehmen
  $('.empfehlung-sbr-assume').on('click', function() {
    if (Number($(this).attr('data-dosage')) > 0) {
      $('input.dosisProHlGui').val($(this).attr('data-dosage')).trigger('change');
    }
  });

  // Calc
  const psmRow = $('.psm-mittel-row');
  $('input.dosisProHlGui').on('keyup change paste', function() {
    spritzung_calc(spritzung_buildAbschnittData(false, Number(psmRow.find('input.psm_mittel_teilspritzung').val()) === 1), {
      type: 'SUMME_DOSIS_PRO_HL_CHANGING',
      previewData: true,
      mittelId: psmRow.data('psm-id'),
      mittelKey: psmRow.data('key'),
      dosisProHl: $(this).val(),
      isTeilspritzung: Number(psmRow.find('input.psm_mittel_teilspritzung').val()) === 1,
    });

    psmRow.find('.last-edit-field').val('dosisHl');
    spritzung_checkUnterdosierung();
    spritzung_checkUeberdosierung();
  });

  $('input.sumMittelmengeGui').on('keyup change paste', function() {
    spritzung_calc(spritzung_buildAbschnittData(false, Number(psmRow.find('input.psm_mittel_teilspritzung').val()) === 1), {
      type: 'SUMME_MITTELMENGE_CHANGING',
      previewData: true,
      mittelId: psmRow.data('psm-id'),
      mittelKey: psmRow.data('key'),
      mittelmenge: $(this).val(),
      noCalc_sumMittelmenge: true,
    });

    psmRow.find('.last-edit-field').val('mittelmengeEffektiv');
    spritzung_checkUnterdosierung();
    spritzung_checkUeberdosierung();
  });

  $('input.sumMittelmengeProHaGui').on('keyup change paste', function() {
    spritzung_calc(spritzung_buildAbschnittData(false, Number(psmRow.find('input.psm_mittel_teilspritzung').val()) === 1), {
      type: 'SUMME_MITTELMENGE_PRO_HA_CHANGING',
      previewData: true,
      mittelId: psmRow.data('psm-id'),
      mittelKey: psmRow.data('key'),
      mittelmengeProHa: $(this).val(),
      isTeilspritzung: Number(psmRow.find('input.psm_mittel_teilspritzung').val()) === 1,
    });

    psmRow.find('.last-edit-field').val('mittelmengeProHa');
    spritzung_checkUnterdosierung();
    spritzung_checkUeberdosierung();
  });

  if (psmRow.find('input.psm_mittel_uid').val() !== '') {
    spritzung_calc(spritzung_buildAbschnittData(false, Number(psmRow.find('input.psm_mittel_teilspritzung').val()) === 1), {
      type: 'SUMME_DOSIS_PRO_HL_CHANGING',
      previewData: true,
      mittelId: psmRow.data('psm-id'),
      mittelKey: psmRow.data('key'),
      dosisProHl: $('.dosisProHl').val(),
      isTeilspritzung: Number(psmRow.find('input.psm_mittel_teilspritzung').val()) === 1,
    });

    $('.indicationSelect').trigger('change');
    spritzung_checkUnterdosierung();
    spritzung_checkUeberdosierung();
  }
};

/**
 * spritzung_removeLastStep
 */
window.spritzung_removeLastStep = function() {
  const formID = '#spritzung';

  $('.accordion__kontrollen .accordion__item__body').remove();
  $('.accordion__kontrollen .accordion__item__title').addClass('form-submit').attr('onclick', 'insertAutoLoader(); $(\'' + formID + '\').trigger(\'submit\'); return false;');

  const buttonTriggerSubmit = $('button#trigger-submit');
  buttonTriggerSubmit.find('span').html(LANG_STRINGS.weiter);
  buttonTriggerSubmit.attr('onclick', 'insertAutoLoader(); $(\'' + formID + '\').trigger(\'submit\'); return false;');

  spritzung_bindSetAdditionalText();
};

/**
 * spritzung_bindRemoveLastStep
 */
window.spritzung_bindRemoveLastStep = function() {
  $('form#spritzung').find('input, select, textarea').change(function() {
    spritzung_removeLastStep();
  });
};

/**
 * openSpritzungError
 * @param element
 */
window.spritzung_goToError = function(element) {
  const sectionID = $(element).attr('data-section-id');
  if (sectionID) {
    const foundRow = $('#list_aufzeichnungFlaechenSpritzung').find('div.tree-item[data-section-uid=' + sectionID + ']');
    if (!foundRow.closest('div.accordion__item').hasClass('accordion__item--active')) {
      foundRow.closest('div.accordion__item').find('div.accordion__item__title').trigger('click');
    }

    if (!foundRow.hasClass('tree-item--active')) {
      foundRow.find('div.tree-item__heading__trigger').trigger('click');
    }

    $('html, body').animate({
      scrollTop: parseInt(foundRow.find('div.tree-item__heading__trigger').offset().top) - 40,
    }, 100);
  }
};

/**
 * spritzung_bindChangingFields
 * @param recordID
 * @param savedDate
 */
window.spritzung_bindChangingFields = function(recordID, savedDate) {
  let timeout = null;

  // Change Date
  $('#aufzeichnung-einsatzdatum-start').on('keyup change', function() {
    const element = this;
    const currentDate = $(element).val();
    const savedTime = $('#aufzeichnung-einsatzzeit-von').val();

    if (currentDate !== savedDate) {
      $('#trigger-submit').attr('disabled', 'disabled');

      clearTimeout(timeout);
      timeout = setTimeout(function() {
        if (currentDate) {
          try {
            const parsedCurrentDate = new Date(currentDate);
            const parsedSavedDate = new Date(savedDate);
            if (parsedCurrentDate.getFullYear() !== parsedSavedDate.getFullYear()) {
              ajaxDialog(BASE_PATH + 'ajax/dialog/aufzeichnungen/ajax.editEingabeDateYear?type=pflanzenschutz&recordID=' + recordID + '&savedDate=' + savedDate + '&currentDate=' + currentDate + '&savedTime=' + savedTime);
            } else {
              $.ajax({
                url: BASE_PATH + 'ajax/helper/aufzeichnungen/ajax.checkChangeDate',
                data: {
                  type: 'pflanzenschutz',
                  recordID: recordID,
                  savedDate: savedDate,
                  currentDate: currentDate,
                  savedTime: savedTime,
                },
                dataType: 'json',
                type: 'get',
                success: function(returnValue) {
                  if (returnValue['success']) {
                    if (returnValue['reload']) {
                      location.reload();
                    } else {
                      $('#fromEditDate').val(1);
                      $('form.form-record').submit();
                    }
                  } else {
                    ajaxDialog(BASE_PATH + 'ajax/dialog/aufzeichnungen/ajax.editEingabeDate?type=pflanzenschutz&savedDate=' + savedDate);
                  }
                },
              });
            }
          } catch (e) {
          }
        }

        $('#trigger-submit').removeAttr('disabled');
      }, 1000);
    }
  });
};

/**
 * spritzung_bindChangingCulture
 * @param recordID
 */
window.spritzung_bindChangingCulture = function(recordID) {

  // Change Culture
  $('.culture-checkbox').on('click', function() {
    const action = $(this).is(':checked') ? 'check' : 'uncheck';
    const kulturID = $(this).val();

    // Step 1:
    if (recordID === 0) {
      if (kulturID === '400') {
        $('#kultur-list').find('.culture-checkbox:checkbox:checked').not('#kultur_400').each(function() {
          $(this).prop('checked', false);
        });
      } else {
        if ($('#kultur_400:checkbox').is(':checked')) {
          $('#kultur_400').prop('checked', false);
        }
      }

      if (action === 'check') {
        $.ajax({
          url: BASE_PATH + 'ajax/helper/aufzeichnungen/ajax.setEingabeEquipment',
          data: {
            type: 'pflanzenschutz',
            kulturID: kulturID,
          },
          dataType: 'json',
          type: 'post',
          success: function(returnValue) {
            if (returnValue !== '') {
              var tableGeraeteBody = $('#table-geraete tbody');
              tableGeraeteBody.find('tr.sprueher').remove();
              tableGeraeteBody.append(returnValue);
              tableGeraeteBody.find('tr.equipment-error').remove();
              // Bind spritzung_removeLastStep
              spritzung_removeLastStep();
            }
          },
        });
      }
    } else {
      if (action === 'uncheck') {
        ajaxDialog(BASE_PATH + 'ajax/dialog/aufzeichnungen/ajax.editEingabeCultureChange?type=pflanzenschutz&kulturID=' + kulturID + '&recordID=' + recordID);
      } else {
        if (kulturID === '400') {
          let kulturen = '';
          $('#kultur-list').find('.culture-checkbox:checkbox:checked').not('#kultur_400').each(function() {
            if (kulturen === '') {
              kulturen += $(this).val();
            } else {
              kulturen += ',' + $(this).val();
            }
          });
          ajaxDialog(BASE_PATH + 'ajax/dialog/aufzeichnungen/ajax.editEingabeCultureChange?type=pflanzenschutz&kulturID=' + kulturID + '&recordID=' + recordID + '&checkweinbau=' + kulturen);
        } else {
          if ($('#kultur-list').find('#kultur_400:checkbox').is(':checked')) {
            ajaxDialog(BASE_PATH + 'ajax/dialog/aufzeichnungen/ajax.editEingabeCultureChange?type=pflanzenschutz&kulturID=' + kulturID + '&recordID=' + recordID + '&checkweinbau=400');
          } else {
            $.ajax({
              url: BASE_PATH + 'ajax/helper/aufzeichnungen/ajax.setEingabeCulture',
              data: {
                type: 'pflanzenschutz',
                recordID: recordID,
                kulturID: kulturID,
                action: action,
              },
              dataType: 'json',
              type: 'post',
              success: function() {
                window.location.reload();
              },
            });
          }
        }
      }
    }
  });
};

/**
 * spritzung_setAccordionField
 * @param type
 * @returns {string|*}
 */
window.spritzung_setAccordionField = function(type) {
  if (type === 'recordType') {
    const inputChecked = $('.record-type').find('input[type="radio"]:checked');
    return inputChecked.closest('label').find('.label').text();
  }

  if (type === 'kulturen') {
    const kulturNames = [];
    $('#kultur-list').find('input[type="checkbox"]:checked').each(function() {
      kulturNames.push($(this).closest('label').data('string'));
    });

    return kulturNames.join(', ');
  }

  if (type === 'datum') {
    const date = new Date($('#aufzeichnung-einsatzdatum-start').val());
    return date.toLocaleDateString('de-DE', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  }

  if (type === 'flaeche') {
    const abschnittData = spritzung_buildAbschnittData();
    return numberFormat(abschnittData.summe.flaeche / 10000, DECIMAL_PLACES_FLAECHE_HA_GUI, ',', '.') + ' ha';
  }

  if (type === 'flaeche-teilspritzung') {
    const abschnittData = spritzung_buildAbschnittData(false, true);
    let summe = {};
    $.each(abschnittData.summe.alleMittelId, function(key, value) {
      summe[value] = 0;
    });
    $.each(abschnittData.abschnitte, function(key, value) {
      $.each(value.mittel, function(key2) {
        summe[key2] += value.flaeche;
      });
    });
    $.each(summe, function(key, value) {
      summe[key] = numberFormat(value / 10000, DECIMAL_PLACES_FLAECHE_HA_GUI, ',', '.') + ' ha';
    });
    return summe;
  }

  if (type === 'bruehe') {
    const konzentrationFaktorSelect = $('#konzentration-faktor option:selected');

    let konzentrationFaktor;
    if (konzentrationFaktorSelect.length > 0) {
      konzentrationFaktor = numberFormatAuto(konzentrationFaktorSelect.val(), 1);
    } else {
      konzentrationFaktor = numberFormatAuto($('#konzentration-faktor').val(), 1);
    }

    return numberFormat($('#bruehe-effektiv').val(), 3, ',', '.') + ' hl (' + konzentrationFaktor + '-fach)';
  }

  if (type === 'mittel') {
    const psmNames = [];
    $('#table-mittel').find('.list-mittelName').each(function() {
      psmNames.push($(this).val());
    });

    return psmNames.join(', ');
  }
};

/**
 * spritzung_bindSetAdditionalText
 */
window.spritzung_bindSetAdditionalText = function() {
  const spritzungLayout = $('#spritzung');
  spritzungLayout.find('div.accordion__item__title__additional').each(function() {
    // Set RecordType
    if ($(this).find('.sub-record-type').length > 0) {
      $(this).find('.sub-record-type').html(spritzung_setAccordionField('recordType'));
    }

    // Set Kulturen
    if ($(this).find('.sub-kulturen').length > 0) {
      $(this).find('.sub-kulturen').html(spritzung_setAccordionField('kulturen'));
    }

    // Set Datum
    if ($(this).find('.sub-datum').length > 0) {
      $(this).find('.sub-datum').html(spritzung_setAccordionField('datum'));
    }

    // Set Fläeche
    if ($(this).find('.sub-flaeche').length > 0) {
      $(this).find('.sub-flaeche').html(spritzung_setAccordionField('flaeche'));
    }

    // Set Fläeche Teilspritzung
    if ($(this).find('.sub-flaeche-teilspritzung').length > 0) {
      const label = spritzung_setAccordionField('flaeche-teilspritzung');
      $.each(label, function(key, value) {
        $('.accordion__item[data-mittel-id="' + key + '"]').find('.sub-flaeche-teilspritzung').html(value);
      });
    }

    // Set Brühe
    if ($(this).find('.sub-bruehe').length > 0) {
      $(this).find('.sub-bruehe').html(spritzung_setAccordionField('bruehe'));
    }

    // Set Mittel
    if ($(this).find('.sub-mittel').length > 0) {
      $(this).find('.sub-mittel').html(spritzung_setAccordionField('mittel'));
    }
  });

  spritzungLayout.find('div.accordion__item__title__additional').removeClass('display-none');
};

/**
 * spritzung_bindAddMittelAbschnitt
 */
window.spritzung_bindAddMittelAbschnitt = function() {
  initTooltip();
};

/**
 * spritzung_resetBruehe
 */
window.spritzung_resetBruehe = function() {

  spritzung_calc(spritzung_buildAbschnittData(true), {
    type: 'RESET_BRUEHE',
  });

  spritzung_removeLastStep();
};

// Document-Ready
$(function() {
  if (MODULE_FILE === 'spritzung') {
      let accGroup = $('.accordion');
    // Eingabe Wasseraufwand
    $('#wasseraufwand-edit').on('keyup change paste', function() {
      let dataSectionID = $('[data-section-uid]');
      let wasseraufwandHa = $(this).val();
      // Wasseraufwand überschreiben
      dataSectionID.has('input:checked').map(function() {
        if (wasseraufwandHa === '') {
          const currentWasseraufwand = $(this).find('input[name="wasseraufwand"]').data('current');
          $(this).find('input[name="wasseraufwand"]').val(currentWasseraufwand);
        } else {
          $(this).find('input[name="wasseraufwand"]').val(wasseraufwandHa);
        }
      });
      if (wasseraufwandHa === '') {
        $('#wasseraufwandHa-intern').val(0);
        $(this).parent().next('.hint-message').addClass('display-none');
      } else {
        $('#wasseraufwandHa-intern').val(wasseraufwandHa);
      }

      spritzung_calc(spritzung_buildAbschnittData(), {
        type: 'SUMME_WASSERAUFWAND_CHANGING',
        bruehmenge: Number($('#bruehe-einfach').val()),
        konzentrationFaktor: Number($('#konzentration-faktor').val()),
      });
    });
    // Eingabe Brühe 1-fach
    $('#bruehe-einfach').on('keyup change paste', function() {
      $('#wasseraufwand-edit').parent().next('.hint-message').addClass('display-none');
      spritzung_calc(spritzung_buildAbschnittData(), {
        type: 'SUMME_BRUEHMENGE_CHANGING',
        bruehmenge: Number($('#bruehe-einfach').val()),
        konzentrationFaktor: Number($('#konzentration-faktor').val()),
        noCalc_brueheEinfach: true,
      });
    });

    // Eingabe Konzentration
    const konzentrationFaktor = $('#konzentration-faktor');
    konzentrationFaktor.on('keyup change paste', function() {
      spritzung_calc({}, {
        type: 'SUMME_KONZENTRATION_FAKTOR_CHANGING',
        bruehmenge: Number($('#bruehe-einfach').val()),
        konzentrationFaktor: Number(konzentrationFaktor.val()),
        noCalc_KonzentrationFaktor: true,
      });
    });

    konzentrationFaktor.on('blur', function() {
      $(this).val(round(Number($(this).val()), 1));
      spritzung_bindSetAdditionalText();
      $(this).trigger('change');
    });

    // Eingabe Brühe effektiv
    $('#bruehe-effektiv').on('keyup change paste', function() {
      $('#wasseraufwand-edit').parent().next('.hint-message').addClass('display-none');
      const brueheEffektiv = roundBrueheGui(Number($(this).val()));
      const konzentrationFaktor = Number($('#konzentration-faktor').val());
      const brueheCalc = brueheEffektiv * konzentrationFaktor;

      spritzung_calc(spritzung_buildAbschnittData(), {
        type: 'SUMME_BRUEHMENGE_CHANGING',
        bruehmenge: brueheCalc,
        konzentrationFaktor: konzentrationFaktor,
        noCalc_brueheEffektiv: true,
      });
    });

    // Eingabe Abschnitt Brühmenge
    $('.abschnitt-bruehmenge').on('keyup change paste', function() {
      $(this).closest('div.abschnitt-bruehmenge-data').find('input.abschnitt-bruehmenge-intern').val(roundBruehe($(this).val(), PSM_BRUEHE_GESAMT_BRUEHE_ABSCHNITT_AUFRUNDEN));

      spritzung_calc(spritzung_buildAbschnittData(), {
        type: 'ABSCHNITT_BRUEHMENGE_CHANGING',
        idAbschnitt: $(this).closest('div.third-level').find('input[type="checkbox"]:checked').val(),
        bruehmenge: Number($(this).val()),
        konzentrationFaktor: Number($('#konzentration-faktor').val()),
        noCalc_abschnittBruehmenge: true,
      });
    });

    // Recalc Eingesetzte Mittel
    spritzung_recalcRowMittel();
    spritzung_recalcRowMittel(true);

    // Bind spritzung_bindRemoveLastStep
    spritzung_bindRemoveLastStep();
    spritzung_bindChangeAccordionText();
  }
});

window.spritzung_bindChangeAccordionText = function(){
    $('.accordion__item').on('click', function() {
        $('.accordion__item').each(function(){
            if($(this).hasClass('accordion__item--active')){
                $(this).find('.ellipsis.titleInactive').addClass('display-none');
                $(this).find('.titleActive').removeClass('display-none').parent().addClass('col-md-12').removeClass('col-md-3');
            }
            else{
                $(this).find('.ellipsis.titleInactive').removeClass('display-none');
                $(this).find('.titleActive').addClass('display-none').parent().removeClass('col-md-12').addClass('col-md-3');;
            }
        })

    });
}

/**
 *
 * @param primaryID
 * @param secondaryID
 * @param tertiaryID
 */
window.updateTeilspritzungen = function(primaryID, secondaryID = 0, tertiaryID = 0) {
  if (tertiaryID !== 0) {
    $('.teilspritzung-abschnitt-' + tertiaryID).prop('checked', false).trigger('deselect');
  } else if (secondaryID !== 0) {
    $('.teilspritzung-anlage-' + secondaryID).prop('checked', false).trigger('deselect');
  } else {
    $('.tree-aufzeichnungen-teilspritzung').each(function() {
      $('.teilspritzung-betrieb-' + primaryID).prop('checked', false).trigger('deselect');
    });
  }
};